import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useState } from "react";
import { CustomerSidebar } from "@/components/customer/CustomerSidebar";
import { CustomerTopbar } from "@/components/customer/CustomerTopbar";

export const Route = createFileRoute("/portal")({
  component: PortalLayout,
});

function PortalLayout() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="flex min-h-screen w-full bg-background">
      <CustomerSidebar collapsed={collapsed} />
      <div className="flex min-w-0 flex-1 flex-col">
        <CustomerTopbar onToggleSidebar={() => setCollapsed((c) => !c)} />
        <main className="flex-1 p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
